import { Trans, useTranslation } from 'react-i18next';
import Editor from 'react-simple-code-editor';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import Prism from 'prismjs';
import { isGranted } from 'helpers/helpers';
import roles from 'helpers/roles';
import RegularButton from 'components/CustomButtons/Button.jsx';
import CustomInput from 'components/CustomInput/CustomInput';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import SelectInput from 'components/FormSelect/SelectInput';

import 'views/MailReminders/style.css';

const useStyles = makeStyles({
  hoursAmount: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  infoIcon: { fontSize: '16px' },
  labeledCheckbox: {
    marginLeft: '8px',
  },
  editor: {
    fontFamily: '"Fira code", "Fira Mono", monospace',
    fontSize: '12px',
  },
});

const EndOfDietReminders = ({
  mailing,
  addRow,
  removeRow,
  saveRow,
  handleRow,
  handleEditor,
  handlePrefix,
  handleToggle,
}) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const getPrefixValue = hours => {
    let value;
    if (hours > 0) {
      value = '+';
    }
    if (hours < 0) {
      value = '-';
    }
    if (hours === '0' || hours === 0) {
      value = '0';
    }

    return value;
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Tooltip
              // eslint-disable-next-line react/jsx-key -- FIXME
              title={<Trans i18nKey="reminders.content" components={[<p />]} />}
            >
              <div className={classes.hoursAmount}>
                {t('common.hoursAmount')}
                <Info className={classes.infoIcon} />
              </div>
            </Tooltip>
          </TableCell>
          <TableCell>{t('common.finishMoment')}</TableCell>
          <TableCell>
            {t('reminders.acceptedClientEmailMarketingAgreement')}
          </TableCell>
          <TableCell>
            {t('reminders.ignoreClientEmailMarketingAgreement')}
          </TableCell>
          <TableCell>{t('common.messageContent')}</TableCell>
          {(isGranted(roles.ROLE_EDIT_END_OF_DIET_REMINDER) ||
            isGranted(roles.ROLE_REMOVE_END_OF_DIET_REMINDER)) && (
            <TableCell>{t('notify.actions')}</TableCell>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {mailing.end_of_diet_reminder_config.map((row, index) => (
          <TableRow key={index}>
            <TableCell width="12%" component="th" scope="row">
              <CustomInput
                formControlProps={{ fullWidth: false }}
                inputProps={{
                  disabled: false,
                  type: 'number',
                  placeholder: t('common.enterValue'),
                  name: 'hours',
                  value: row.hours,
                  onChange: e => handleRow(e, index),
                }}
              />
            </TableCell>
            <TableCell width="20%" component="th" scope="row">
              <SelectInput
                options={[
                  {
                    label: t('endOfDietOptions.beforeFinish'),
                    value: '-',
                  },
                  {
                    label: t('endOfDietOptions.afterFinish'),
                    value: '+',
                  },
                  {
                    label: t('endOfDietOptions.atTheLastDay'),
                    value: '0',
                  },
                ]}
                mapBy="label"
                trackBy="value"
                value={getPrefixValue(row.hours)}
                handleChange={e => {
                  handlePrefix(e, index);
                }}
              />
            </TableCell>
            <TableCell width="12%" component="th" scope="row">
              <LabeledCheckbox
                className={classes.labeledCheckbox}
                name="acceptedClientMarketingAgreement"
                checked={row.acceptedClientMarketingAgreement}
                onChange={event => handleToggle(event, index)}
              />
            </TableCell>
            <TableCell width="12%" component="th" scope="row">
              <LabeledCheckbox
                className={classes.labeledCheckbox}
                name="ignoreClientMarketingAgreement"
                checked={row.ignoreClientMarketingAgreement}
                onChange={event => handleToggle(event, index)}
              />
            </TableCell>
            <TableCell width="60%" component="th" scope="row">
              <Editor
                className={classes.editor}
                value={row.template}
                onValueChange={code => handleEditor(code, 'template', index)}
                highlight={code =>
                  Prism.highlight(code, Prism.languages.html, 'html')
                }
                padding={10}
              />
            </TableCell>
            <TableCell>
              {isGranted(roles.ROLE_EDIT_END_OF_DIET_REMINDER) && (
                <RegularButton
                  fullWidth={true}
                  disabled={!row.hasChanged}
                  color="success"
                  onClick={() => saveRow(index)}
                >
                  {t('form.save')}
                </RegularButton>
              )}
              {isGranted(roles.ROLE_REMOVE_END_OF_DIET_REMINDER) && (
                <RegularButton
                  fullWidth={true}
                  color="danger"
                  onClick={() => removeRow(index)}
                >
                  {t('form.delete')}
                </RegularButton>
              )}
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell
            className="variant-addRow"
            colSpan={6}
            align="center"
            onClick={addRow}
          >
            {t('remonders.addNotification')}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default EndOfDietReminders;
